export const LABEL_PLACEMENT = {
  START: 'start',
  END: 'end',
} as const;

export type LabelPlacement =
  (typeof LABEL_PLACEMENT)[keyof typeof LABEL_PLACEMENT];
